export default "__VITE_ASSET__Dh2n$WUV__"